<template>
  <div class="buyAgain">
    <HeaderTop ref="shopcar"></HeaderTop>
    <div class="buyAgain-main">
      <div class="main-top">
        <img src="@/assets/images/home/logo1.png" alt="" />
        <span>再次购买</span>
      </div>
      <div class="main-body">
        <div class="w11">
          <div class="w12">
            <Input
              v-model="searchlist.keywords"
              placeholder="配件编码/配件名称"
              style="width: 250px"
            />
            <Button
              type="primary"
              style="margin: 0 20px"
              @click="getAgainlist()"
              >查询</Button
            >
            <Button type="primary" class="w14" @click="agaginSearch()"
              >重新查询</Button
            >
          </div>
          <div class="w13">
            <Button type="primary" @click="agaginSet()">重新设置</Button>
            <Button
              type="primary"
              style="margin-left: 20px"
              @click="hidenNobuy()"
              >{{ isSell ? '隐藏' : '显示' }}不可购买商品</Button
            >
          </div>
        </div>
        <!-- 表头 -->
        <div class="w22" v-if="dataList.length > 0">
          <Row class="tableHeader">
            <Col span="7" style="padding-left: 10px">商品信息</Col>
            <Col span="3">发货地</Col>
            <Col span="2">库存</Col>
            <Col span="3">上次购买单价(元)</Col>
            <Col span="3">当前单价（元）</Col>
            <Col span="3">购买数量</Col>
            <Col span="3">小计（元）</Col>
          </Row>
        </div>
        <!-- 内容 -->
        <div class="table">
          <div class="w33" v-if="dataList.length > 0">
            <span class="w34 w344" v-if="dataName.storeTypeName == '自营'">{{
              dataName.storeTypeName
            }}</span>
            <span class="w34 w345" v-else>{{ dataName.storeTypeName }}</span>
            <xiaopei
              :oppositeTenantId="dataName.sellerTenantId"
              style="padding-top: 3px"
              ><i class="iconfont icon-a-lujing162"></i
            ></xiaopei>
            <span class="w35">{{ dataName.tenantShortName }}</span>
          </div>
          <transition-group
            name="more"
            v-bind:css="false"
            v-on:before-enter="beforeEnter"
            v-on:enter="enter"
            v-if="dataList.length > 0"
          >
            <div
              class="tableCenter"
              v-for="(item, index) in dataList"
              :key="item.partsId"
              id="aaa"
            >
              <div class="w37">
                <div class="w36">
                  <img
                    v-if="item.pictureUrl"
                    :src="item.pictureUrl"
                    alt="图片缺失"
                  />
                  <img
                    v-else
                    src="@/assets/images/shoppingCart/2.png"
                    alt="图片缺失"
                  />
                  <div class="w361">
                    <p class="w362">
                      <i class="w3611" v-if="item.partsQuality == 71">
                        {{ item.partsQualityName }}</i
                      >
                      <i v-else> {{ item.partsQualityName }}</i>
                      {{ item.partCode }}
                    </p>
                    <p>{{ item.carBrandName }}</p>
                    <p>
                      {{ item.direction }}{{ item.stdNameJp
                      }}{{ item.oilGrade }}
                    </p>
                    <div class="oe-p" @mouseleave="closeRelevance(index)">
                      OE号：
                      <p
                        @mouseenter="getRelevance(index)"
                        v-if="item.oeCodes.length"
                      >
                        {{ item.oeCodes[0]
                        }}<i
                          class="ivu-icon ivu-icon-ios-arrow-down"
                          v-if="item.oeCodes.length > 1"
                        ></i>
                      </p>
                      <div
                        class="relevance"
                        :tabIndex="1"
                        v-if="item.oeCodes.length > 1"
                      >
                        <div
                          class="relevanceBox"
                          :class="item.isShow ? 'show' : ''"
                        >
                          <!-- 关联原厂件号： -->
                          <p v-for="i in item.oeCodes.slice(1)" :key="i">
                            {{ i }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <ul style="display= flex;flex-flow: wrap;">
                      <li>服务：</li>
                      <li v-if="item.genuineGuarantee">
                        <span class="iconfont icon-a-lujing153"></span>
                      </li>
                      <li v-if="item.technicalSupport">
                        <span class="iconfont icon-a-ziyuan4"></span>
                      </li>
                      <li v-if="item.warrantyService">
                        <span class="iconfont icon-a-ziyuan5"></span>
                      </li>
                      <li v-if="item.returnPromise">
                        <span class="iconfont icon-a-ziyuan21"></span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="w38">
                  <Row
                    v-for="val in item.partsStoreDetailList"
                    :key="val.id"
                    class="w381"
                  >
                    <!-- 发货地 -->
                    <Col span="5" class="w120">
                      <div class="oe-p" @mouseleave="closeCity(val)">
                        <p
                          class="w122"
                          @mouseenter="getCity(val)"
                          v-if="val.shipCityStores.length"
                        >
                          {{ val.shipCityStore.city }}
                          {{ val.shipCityStore.name }}
                          <i
                            class="ivu-icon ivu-icon-ios-arrow-down"
                            v-if="val.shipCityStores.length > 1"
                          ></i>
                        </p>
                        <div
                          class="relevance"
                          :tabIndex="1"
                          v-if="val.shipCityStores.length > 1"
                        >
                          <div
                            class="relevanceBox w33"
                            :class="val.isShows ? 'show' : ''"
                          >
                            <p
                              v-for="i in val.shipCityStores"
                              :key="i.storeId"
                              class="w22"
                              :class="isCity === i.name ? 'isCityed' : ''"
                              @click="checkCITY(i, val)"
                            >
                              {{ i.city }}
                              {{ i.name }}
                            </p>
                          </div>
                        </div>
                        <!-- </p> -->
                      </div>
                    </Col>
                    <Col span="3" class="flexCenter">
                      {{ val.shipCityStore.stock &lt; 10 ? val.shipCityStore.stock :'10+'

                      }}/{{ val.unitId }}
                    </Col>
                    <Col span="4" style="font-weight: 600">
                      ￥ {{ val.lastPrice }}
                    </Col>
                    <Col span="4" style="font-weight: 600">
                      <span
                        v-if="val.state == 1 || val.state == 2"
                        style="color: #f62b4e; font-size: 16px"
                        >{{ val.stateName }}</span
                      >
                      <span v-else>￥{{ val.price }}</span>
                    </Col>
                    <Col span="4">
                      <div
                        class="number"
                        v-if="val.state == 1 || val.state == 2"
                      >
                        <div class="number-in">
                          <!-- <Button
                            style="border-right: 1px solid #dcdee2"
                            class="number-sub"
                            disabled
                            >-</Button
                          >
                          <input
                            oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                            disabled
                            v-model="disabledVal"
                            style="
                              width: 50px;
                              text-align: center;
                              line-height: 31px;
                            "
                          />
                          <Button class="number-add" disabled>+</Button> -->
                          <input
                            oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                            disabled
                            :value="disabledVal"
                            style="
                              width: 50px;
                              text-align: center;
                              line-height: 31px;
                            "
                          />
                        </div>
                        <div
                          class="number-sp"
                          :class="val.isNumber ? 'show' : ''"
                        >
                          库存不足
                        </div>
                      </div>
                      <div class="number" v-else>
                        <div class="number-in">
                          <!-- <Button
                            style="border-right: 1px solid #dcdee2"
                            class="number-sub"
                            @click="cliSub(val, val.id)"
                            :disabled="item.Sub"
                            >-</Button
                          >
                          <input
                            oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                            :id="val.id"
                            @blur="BlurNumber(val)"
                            v-model="val.partNum"
                            style="
                              width: 50px;
                              text-align: center;
                              line-height: 31px;
                            "
                          />
                          <Button
                            class="number-add"
                            @click="cliAdd(val, val.id)"
                            :disabled="val.Add"
                            >+</Button
                          > -->
                          <input
                            oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                            :id="val.id"
                            @blur="BlurNumber(val)"
                            :value="val.partNum"
                            style="
                              width: 50px;
                              text-align: center;
                              line-height: 31px;
                            "
                          />
                        </div>
                        <div
                          class="number-sp"
                          :class="val.isNumber ? 'show' : ''"
                        >
                          库存不足
                        </div>
                      </div>
                    </Col>
                    <Col span="3">
                      <span class="w39" v-if="val.state == 1 || val.state == 2"
                        >0</span
                      >
                      <span class="w39" v-else>￥{{ val.subtotal }}</span>
                    </Col>
                    <!-- <Col span="1">
                      <Icon
                        type="md-close"
                        size="20px"
                        color="#505050"
                        style="font-weight: 600"
                        @click="del(val)"
                      />
                    </Col> -->
                  </Row>
                  <div v-if="item.isAddableShipStore" class="w40">
                    <p @click="addstore(item)">添加发货地</p>
                  </div>
                </div>
              </div>
            </div>
          </transition-group>
          <!-- 数据为空 -->
          <div class="emptyData" v-if="dataList.length == 0">
            <p>
              <span
                ><i
                  ><Icon
                    type="ios-alert-outline"
                    size="17"
                  />没找到您想要的数据~</i
                ></span
              >
            </p>
          </div>
          <!-- 加载中 -->
          <div class="demo-spin-container" v-if="spinShow">
            <Spin fix></Spin>
          </div>
        </div>
        <div style="display: flex; justify-content: right; margin: 10px 0">
          <!-- 分页 -->
          <Page
            :total="pager.total"
            :current="pager.current"
            :page-size="pager.size"
            size="small"
            :page-size-opts="[30]"
            show-total
            @on-change="changeCurrent"
            @on-page-size-change="changeSize"
          />
          <span
            style="
              line-height: 11px;
              height: 26px;
              padding: 7px 10px;
              border: 1px solid #dcdee2;
              border-radius: 3px;
            "
            >30条/页</span
          >
        </div>
      </div>
      <Affix :offset-bottom="0">
        <div class="main-fotter">
          <!-- <div style="width:200px"></div> -->
          <!-- <div></div> -->
          <span class="w4"
            >已选商品：<i>{{ counter }}</i
            >&nbsp;种</span
          >
          <span class="w4"
            >数量：<i>{{ totalCount }}</i
            >&nbsp;件</span
          >
          <span class="w4"
            >商品金额（不包含运费）：<i class="w3">￥{{ totalPrice }}</i></span
          >
          <span><i></i></span>
          <span class="w1" @click="buy()">立即购买</span>
          <!-- <span class="w1 w2" @click="buyShopping()">加入购物车</span> -->
        </div>
      </Affix>
    </div>
    <enquirytk
      ref="enquirytkl"
      :enquirydata="enquirydata"
      @enquirysx="enquirysx"
    ></enquirytk>
    <Slider></Slider>
    <Footer></Footer>
    <FooterP></FooterP>
  </div>
</template>

<script>
import HeaderTop from '../base/common/header-top.vue'
import Slider from '../base/common/slider.vue'
import Footer from '../base/common/footer.vue'
import FooterP from '@/views/base/common/footer-p.vue'
import xiaopei from '@/views/xiaopei/index.vue'
import enquirytk from '../base/common/enquirytk.vue'
import { index } from './index'
import {
  getAgainlist,
  addstore,
  latent,
  carts,
  del,
  prebuys,
  setAgain
  // switchStore
} from '@/api/buyagain.js'
export default {
  components: { HeaderTop, Footer, Slider, xiaopei, FooterP, enquirytk },
  mixins: [index],
  data() {
    return {
      counter: '', // 商品种类
      isSell: true,
      disabledVal: '0',
      enquirydata: {}, // 询价数据
      spinShow: true,
      // value: '',
      dataList: [], // 列表数据
      dataName: {},
      searchlist: {
        ordersCode: this.$route.query.ordersCode,
        size: 30,
        current: 1,
        keywords: ''
      },
      pager: {
        current: 1,
        total: 0,
        size: 30
      },
      totalCount: 0,
      totalPrice: 0,
      latent: 1
    }
  },
  created() {
    this.getAgainlist()
    // this.getCount()
  },
  methods: {
    // 获取列表数据
    async getAgainlist() {
      const res = await getAgainlist({
        ordersCode: this.searchlist.ordersCode,
        size: this.searchlist.size,
        current: this.searchlist.current,
        keywords: this.searchlist.keywords
      })
      // console.log(res)
      if (res.status) {
        if (res.data.ipage !== null) {
          this.dataList = res.data.ipage.records
          this.dataName = res.data
          this.counter = res.data.counter
          this.getCount()
          this.pager.total = res.data.ipage.total
        } else {
          this.dataList = []
          this.dataName = ''
        }
      } else {
        this.dataList = []
        this.dataName = ''
      }
      this.spinShow = false
    },
    // 计算商品的数量
    getCount() {
      this.totalCount = 0
      this.totalPrice = 0
      const arr = JSON.parse(JSON.stringify(this.dataList))
      arr.forEach((item) => {
        item.partsStoreDetailList.forEach((i) => {
          console.log(i);
          if (i.state == 0) {
            i.partNum = Number(i.partNum)
            this.totalCount += i.partNum
            this.totalPrice += i.subtotal
          }
        })
      })
      // console.log(this.totalCount)
      // console.log(this.totalPrice)
    },
    // 增加发货仓
    async addstore(item) {
      console.log(item)
      const res = await addstore({
        code: this.searchlist.ordersCode,
        partsId: item.partsId
      })
      console.log(res)
      if (res.status) {
        item.partsStoreDetailList.push(res.data)
        item.isAddableShipStore = res.data.isAddableShipStore
        this.getCount()
      }
    },
    // 重新查询
    agaginSearch() {
      this.searchlist.keywords = ''
      this.getAgainlist()
    },
    // 重新设置
    async agaginSet() {
      this.searchlist = {
        ordersCode: this.$route.query.ordersCode,
        size: 30,
        current: 1,
        keywords: ''
      }
      const res = await setAgain({ code: this.$route.query.ordersCode })
      console.log(res)
      if (res.status) {
        this.getAgainlist()
      }
    },
    // 隐藏不可购买商品
    async hidenNobuy() {
      // var latent = 1
      if (this.isSell) {
        this.latent = 1
        this.isSell = false
      } else {
        this.latent = 0
        this.isSell = true
      }
      const res = await latent({
        code: this.searchlist.ordersCode,
        latent: this.latent
      })
      console.log(res)
      if (res.status) {
        this.getAgainlist()
      }
    },
    // 加入购物车
    async buyShopping() {
      const res = await carts({ code: this.searchlist.ordersCode })
      console.log(res)
      if (res.status) {
        this.$router.push({
          path: '/shoppingCart'
        })
      }
    },
    // 购买商品
    async buy() {
      // const arr = JSON.parse(JSON.stringify(this.dataList))
      // let data = []
      // arr.forEach((item) => {
      //   item.partsStoreDetailList.forEach((val) => {
      //     let arr1 = {}
      //     console.log('22')
      //     arr1.storeId = val.shipCityStore.storeId
      //     arr1.partId = val.partsId
      //     arr1.partNum = val.partNum
      //     arr1.tenantId = this.dataName.sellerTenantId
      //     arr1.ordersCode = this.searchlist.ordersCode
      //     data.push(arr1)
      //   })
      // })
      // console.log(data)
      const res = await prebuys({ ordersCode: this.searchlist.ordersCode })
      console.log(res)
      if (res.status) {
        if(this.dataName.activityType === 3){
          this.$router.push({
            path: '/orderInformation',
            query: {
              pid: res.data.previewOrderId,
              activityType: '3'
            }
          })
        }else{
          this.$router.push({
            path: '/orderInformation',
            query: {
              pid: res.data.previewOrderId
            }
          })
        }
      }
    },
    // 删除商品发货仓
    async del(val) {
      const res = await del({ id: val.id })
      console.log(res)
      if (res.status) {
        this.getAgainlist()
        this.$Message.success('删除成功')
      }
    },
    // 询价刷新
    enquirysx() {
      this.$refs.shopcar.getenquirydata()
    }
  },
  computed: {},
  watch: {}
}
</script>
<style lang='less' scoped>
@import './index.less';
</style>